export enum SIZES {
  EXTRASMALL = "extraSmall",
  SMALL = "small",
  NORMAL = "normal",
  LARGE = "large",
  EXTRALARGE = "extraLarge",
}

export const CLOSE_BUTTON_DATA_TEST = "ModalCloseButton";
